<!--
 * @Description: 新闻
 * @Author: zml
 * @Date: 2023-04-13 18:05:47
 * @LastEditors: xie
 * @LastEditTime: 2024-07-31 15:28:14
-->

<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'newsPage',
  mixins: [mixins],

  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateFour':
          this.componentName = 'pageNewsFour'
          break
        case 'themeTemplateSix':
          this.componentName = 'pageNewsSix'
          break
        case 'themeTemplateSeven':
          this.componentName = 'pageNewsSeven'
          break
        case 'themeTemplateEight':
          this.componentName = 'pageNewsEight'
          break
        case 'themeTemplateTen':
          this.componentName = 'pageNewsTen'
          break
        default:
          this.componentName = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>